export default __webpack_public_path__ + "static/media/Verify.aa1839c9.png";